import Icon from '@cobliteam/colib-ui/Icon';
import { getSingular } from '@cobliteam/utils/pluralize';
import { deviceTypeLabel } from '../../../helpers';
import type { DeviceWithCategory } from '../../../types';

interface ItemContentProps {
  item: DeviceWithCategory;
}

const DeviceItem = ({ item }: ItemContentProps) => {
  if (!item) return null;
  return (
    <button type='button' tabIndex={0} className={'flex w-full items-center justify-between text-xs'}>
      <div className='flex items-center justify-center gap-2'>
        <Icon size='sm' name={item.category.icon} className='text-[#8e4ec6]' />
        <div className='flex flex-col text-left'>
          <span className='text-[10px] text-muted-foreground'>{getSingular(item.category.name)}</span>
          <span className='line-clamp-1'>
            {item.cobliId} - {deviceTypeLabel(item?.generalType)}
          </span>
        </div>
      </div>
    </button>
  );
};

export default DeviceItem;
